import React from 'react';
import '../../../css/admin/chats/EventNotes.css';
import ChatNotesPanel from '../../common/chat/notes/ChatNotesPanel';

const API_URL = process.env.REACT_APP_API_URL;

const AdminGroupNotesPanel = ({ threadId, onModeChange, onNotesChanged, canCreateNote = true, canManageNotes = true }) => (
  <ChatNotesPanel
    ownerId={threadId}
    rootClassName="admin-notes-panel"
    title="ノート"
    buildListUrl={(ownerId, offset = 0, limit = 20) => `${API_URL}/api/admin/group-chat-notes/${ownerId}?offset=${offset}&limit=${limit}`}
    createUrl={`${API_URL}/api/admin/group-chat-notes`}
    buildUpdateUrl={(noteId) => `${API_URL}/api/admin/group-chat-notes/${noteId}`}
    buildDeleteUrl={(noteId) => `${API_URL}/api/admin/group-chat-notes/${noteId}`}
    buildDetailUrl={(noteId) => `${API_URL}/api/group-chat-notes/detail/${noteId}`}
    onModeChange={onModeChange}
    onNotesChanged={onNotesChanged}
    canCreateNote={canCreateNote}
    canManageNotes={canManageNotes}
    openDetailEventName="admin-group-notes-open-detail"
    closeDetailEventName="admin-group-notes-close-detail"
    closeImageEventName="admin-group-notes-close-image"
  />
);

export default AdminGroupNotesPanel;
